import { useQuery } from '@tanstack/react-query';

import { getPaymentPlanComponents } from '~/services/PaymentsService';

export const paymentPlanComponentQueryKeys = {
  all: ['payment-plan-components'] as const,
  details: () => [...paymentPlanComponentQueryKeys.all, 'detail'] as const,
  detail: (orderId: string) => [...paymentPlanComponentQueryKeys.details(), orderId] as const,
};

export function useGetPaymentPlanComponents(orderId: string | undefined) {
  return useQuery({
    queryKey: paymentPlanComponentQueryKeys.detail(orderId ?? ''),
    queryFn: ({ signal }) => {
      if (!orderId) {
        throw new Error('Order ID is required');
      }

      return getPaymentPlanComponents(orderId, signal);
    },
    enabled: Boolean(orderId),
  });
}
